import Link from 'next/link';
import { Image } from '../../../../components/image/image';

const TopHeader = () => {
  return (
    // 1. Wrapper ngoài cho background full-width
    <header className="w-full max-w-[2000px] mx-auto bg-gradient-to-r from-[#FFC0D4] to-[#FFFAFC] py-2">

      {/* 2. Container bên trong để giới hạn nội dung */}
      {/*
        - Mobile (mặc định): Căn giữa nội dung (justify-center)
        - Desktop (từ breakpoint 'md' trở lên): Dàn đều nội dung (md:justify-between)
        - Luôn có max-width là 1200px trên màn hình lớn
      */}
      <div className="mx-auto flex max-w-[1200px] items-center justify-center px-4 md:justify-between lg:justify-between">
        {/* Logo KidsPlaza */}
        {/*
          - hidden: Mặc định ẩn trên mobile
          - md:block: Hiển thị lại từ breakpoint 'md' (768px) trở lên
        */}
        <div className="flex-shrink-0">
          <Link href={'/'}>
              <Image
                src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/kidsplaza-logo.png"
                alt="KidsPlaza Logo"
                width={150}
                height={40}
                className="xxs:w-[100px] xs:w-[150px] h-auto"
              />
          </Link>
        </div>

        {/* Các logo sự kiện */}
        <div className="flex items-center space-x-4 md:space-x-8">
          <div>
            <Image
              src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/festival-2025-logo.png"
              alt="Festival 2025"
              width={100}
              height={50}
              className="h-auto"
            />
          </div>
          <div>
            <Image
              src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/festival-logo-wide.png"
              alt="Mẹ Bầu & Em Bé"
              width={180}
              height={50}
              className="h-auto"
            />
          </div>
          <div className='hidden md:block'>
            <Image
              src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/10-seasons-logo.png"
              alt="10 Year Anniversary"
              width={80}
              height={50}
              className="h-auto"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopHeader;
